export interface TreeData {
    name: string;
    key: string;
    disabled?: boolean;
    child?: Array<TreeData>;
}

export class TreeTransfer {
    treeData: Array<any> | null;

    constructor() {
        this.treeData = null;
    }

    setValue(data: Array<any> | null): void {
        this.treeData = data;
    }

    parseDataWithAllkeys(): Array<string> {
        const result: Array<string> = [];

        if (this.treeData) {
            return this.treeData
        } else {
            return result
        }

    }

    parseData(): Array<number> {
        const result: Array<number> = [];
        this.treeData?.forEach((value: string) => {
            if (value.split("-")) {
                if (value.indexOf("-") !== -1) {
                    const data = value.split("-");
                    result.push(Number(data[1]));
                }
            }
        });
        return result;
    }
}
